import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useUI } from 'src/context/UIContext';

export default function TopBar({ aesthetic }) {
    const { theme, setTheme } = useUI();
    const { pathname } = useLocation();

    const isAuthor   = pathname.startsWith('/books');
    const isEngineer = !isAuthor;

    return (
        <header className="topbar">
            <div className="topbar-inner">
                {/* Wordmark */}
                <Link to="/" className="wordmark">
                    <span className="wordmark-mark">
                        {aesthetic === 'mono' ? '[mb]' : 'MB'}
                    </span>
                    <span className="wordmark-name">Matthew Brinkmann</span>
                </Link>

                {/* Mode toggle */}
                <nav className="mode-toggle" aria-label="Switch mode">
                    <Link
                        to="/books"
                        className={'mode-btn' + (isAuthor ? ' is-active' : '')}
                        aria-current={isAuthor ? 'page' : undefined}
                    >
                        <span className="mode-btn-dot" />
                        Author
                    </Link>
                    <Link
                        to="/"
                        className={'mode-btn' + (isEngineer ? ' is-active' : '')}
                        aria-current={isEngineer ? 'page' : undefined}
                    >
                        <span className="mode-btn-dot" />
                        Engineer
                    </Link>
                </nav>

                {/* Theme toggle */}
                <div className="topbar-right">
                    <button
                        className="theme-toggle-btn"
                        onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
                        aria-label={theme === 'light' ? 'Switch to dark theme' : 'Switch to light theme'}
                        title={theme === 'light' ? 'Switch to dark' : 'Switch to light'}
                    >
                        {theme === 'light' ? '◐' : '◑'}
                    </button>
                </div>
            </div>
        </header>
    );
}
